import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'; // Import the styles
import { forwardRef, useState } from 'react';
import { Badge, Card,Form, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons'; // Import the calendar icon

const GreetingsDateInput = forwardRef(({ value, onClick }, ref) => (
  
  <div className="position-relative">
    <Form.Control
      size="sm"
      ref={ref}
      onClick={onClick}
      value={value}
      className="ps-4"
      onChange={e => {
        console.log({ e });
      }}
    />
    <FontAwesomeIcon
      icon="calendar-alt"
      className="text-primary position-absolute top-50 translate-middle-y ms-2"
    />
  </div>
));

const CustomDatePicker = ({onChange,selected}) => {

  return (
    <DatePicker
      selected={selected}
      onChange={(value)=>onChange(value)}
      dateFormat="MMM d, yyyy"
      customInput={<GreetingsDateInput />}
    />
  );
};

export default CustomDatePicker;
